import { render, staticRenderFns } from "./ChartDoughnut.vue?vue&type=template&id=aacf7252"
import script from "./ChartDoughnut.ts?vue&type=script&lang=ts&external"
export * from "./ChartDoughnut.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports